import React, { useState, useEffect } from 'react';
import styled from 'styled-components'
import { getKidAccountBalance } from '../../../utils/FamilyApiService';
import ClipLoader from "react-spinners/ClipLoader";
import { VictoryChart, VictoryLine, VictoryTheme, VictoryAxis } from "victory";
import Switch from "../Switch/Switch";


const BalanceWrapperStyled = styled.div`
    height: 100%;
`;

const EconomyViewStyled = styled.div`
    height: 100%;
    width: 100%;
    text-align: center;
    margin-top: 20px;
`;

const SwitchContainer = styled.div`
    margin-top: 20px;
    display: inline-block;
`;

const HeaderStyled = styled.div`
    font-size: 30px;
    font-weight: bold;
`;

const ImageStyled = styled.img`
    height: 200px;
    border-radius: 20px;
`;

const BalanceContainerStyled = styled.div`
    margin-top: 20px;
    display: inline-block;
    text-align: left;
`;

const AccountStyled = styled.div`
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
`;

const SpinnerWrapperStyled = styled.div`
    margin-top: 50px;
`;

const BalanceChartStyled = styled.div`
    height: 400px;
    display: inline-block;
`;

const BalanceYearlyChartStyled = styled.div`
    height: 400px;
    display: inline-block;
`;

const AccountIconStyled = styled.span`
    margin-right: 10px;
`;

const PigIconStyled = styled.span`
    color: #f9a195;
`;

const CardIconStyled = styled.span`
    color: #00a98f;
`;

const KidBalance = ({ refreshTrigger, kidName }) => {

    var imageSource = `/images/${kidName}.png`;
    const [loading, setLoading] = useState(false);
    const [kidAccountsDetails, setKidAccountsDetails] = useState({});
    const [minY, setMinY] = useState(0);
    const [maxY, setMaxY] = useState(0);
    const [minYYearly, setMinYYearly] = useState(0);
    const [maxYYearly, setMaxYYearly] = useState(0);

    const [showMonthly, setShowMonthly] = useState(true);

    useEffect(() => {
        setLoading(true);
        getKidAccountBalance(kidName)
            .then((result) => {
                setKidAccountsDetails(result);
                var minValue = Math.min(result.monthlyTotalBalance[0].balance - 10,
                    result.expectedFutureBalance[result.expectedFutureBalance.length - 1].balance - 10
                );
                setMinY(minValue);
                var maxValue = Math.max(
                    result.monthlyTotalBalance[result.monthlyTotalBalance.length - 1].balance + 30,
                    result.expectedFutureBalance[result.expectedFutureBalance.length - 1].balance + 30,
                    result.maxFutureBalance[result.maxFutureBalance.length - 1].balance + 30,);
                setMaxY(maxValue);
                var maxYearlyValue = Math.max(
                    result.maxYearlyFutureBalance[result.maxYearlyFutureBalance.length - 1].balance + 30,
                    result.expectedYearlyFutureBalance[result.expectedYearlyFutureBalance.length - 1].balance + 30,);
                setMaxYYearly(maxYearlyValue);
                var minYearlyValue = Math.min(result.monthlyTotalBalance[0].balance - 10,
                    result.expectedYearlyFutureBalance[result.expectedYearlyFutureBalance.length - 1].balance - 10
                );
                setMinYYearly(minYearlyValue);


                setLoading(false);
                console.log(result);
            })
            .catch((err) => {
                console.log(err);
            })
    }, [refreshTrigger]);

    const balanceList = kidAccountsDetails?.accountList?.map((account) =>
        account.name.toUpperCase().includes('BRUKSKONTO') ?
            <AccountStyled><AccountIconStyled><CardIconStyled><i className="fas fa-credit-card"></i></CardIconStyled></AccountIconStyled>{account.name}: {Number(account.availableBalance).toLocaleString('no-NO')} kr</AccountStyled>
            : <AccountStyled><AccountIconStyled><PigIconStyled><i className="fas fa-piggy-bank"></i></PigIconStyled></AccountIconStyled>{account.name}: {Number(account.availableBalance).toLocaleString('no-NO')} kr</AccountStyled>
    );

    const savingsDevelopmentChartData = kidAccountsDetails?.monthlyTotalBalance?.map(item => ({ x: item.monthName, y: item.balance }));
    const expectedFutureBalance = kidAccountsDetails?.expectedFutureBalance?.map(item => ({ x: item.monthName, y: item.balance }));
    const maxFutureBalance = kidAccountsDetails?.maxFutureBalance?.map(item => ({ x: item.monthName, y: item.balance }));

    const maxYearlyFutureBalance = kidAccountsDetails?.maxYearlyFutureBalance?.map(item => ({ x: item.year, y: item.balance }));
    const expectedYearlyFutureBalance = kidAccountsDetails?.expectedYearlyFutureBalance?.map(item => ({ x: item.year, y: item.balance }));

    return (
        <EconomyViewStyled>
            {loading && (<SpinnerWrapperStyled>
                <ClipLoader
                    color='#75b0e0'
                    loading={loading}
                    size={50}
                />
            </SpinnerWrapperStyled>
            )}
            {!loading && (
                <div>
                    <HeaderStyled>{kidName}</HeaderStyled>
                    <ImageStyled src={imageSource}></ImageStyled>


                    <BalanceWrapperStyled>
                        {showMonthly ? (<BalanceChartStyled>
                            <VictoryChart
                                minDomain={{ y: minY }}
                                maxDomain={{ y: maxY }}
                                theme={VictoryTheme.material}
                            >
                                <VictoryLine
                                    style={{
                                        data: { stroke: "#c43a31" },
                                    }}
                                    data={savingsDevelopmentChartData}
                                    animate={{
                                        duration: 0,
                                        onLoad: { duration: 4000 }
                                    }}
                                />
                                <VictoryLine
                                    style={{
                                        data: { stroke: "blue" },
                                    }}
                                    data={expectedFutureBalance}
                                    animate={{
                                        duration: 0,
                                        onLoad: { duration: 4000 }
                                    }}
                                />
                                <VictoryLine
                                    style={{
                                        data: { stroke: "green" },
                                    }}
                                    data={maxFutureBalance}
                                    animate={{
                                        duration: 0,
                                        onLoad: { duration: 4000 }
                                    }}
                                />
                                <VictoryAxis dependentAxis
                                />

                                <VictoryAxis
                                    style={{ tickLabels: { angle: 90, transform: 'translate(10, 10)' } }}
                                />
                            </VictoryChart>
                        </BalanceChartStyled>) : (
                            <BalanceYearlyChartStyled>
                                <VictoryChart
                                    minDomain={{ y: minYYearly }}
                                    maxDomain={{ y: maxYYearly }}
                                    theme={VictoryTheme.material}
                                >
                                    <VictoryLine
                                        style={{
                                            data: { stroke: "blue" },
                                        }}
                                        data={expectedYearlyFutureBalance}
                                        animate={{
                                            duration: 0,
                                            onLoad: { duration: 4000 }
                                        }}
                                    />
                                    <VictoryLine
                                        style={{
                                            data: { stroke: "green" },
                                        }}
                                        data={maxYearlyFutureBalance}
                                        animate={{
                                            duration: 0,
                                            onLoad: { duration: 4000 }
                                        }}
                                    />
                                    <VictoryAxis dependentAxis
                                    />

                                    <VictoryAxis
                                        tickFormat={(k) => (k)}
                                        style={{ tickLabels: { angle: 90, transform: 'translate(10, 10)' } }}
                                    />
                                </VictoryChart>
                            </BalanceYearlyChartStyled>
                        )}
                        <div />
                        <SwitchContainer>
                            <Switch
                                onColor="#fff"
                                isOn={showMonthly}
                                handleToggle={() => setShowMonthly(!showMonthly)}
                            />
                        </SwitchContainer>
                        <div />
                        <BalanceContainerStyled>
                            {
                                balanceList
                            }
                        </BalanceContainerStyled>
                    </BalanceWrapperStyled>
                </div>
            )}


        </EconomyViewStyled>
    );
};

export default KidBalance;